import React from 'react';
import '../App.css';

const Footer = ({ t }) => {
    return (
        <footer className="footer">
            <div className="footer-creator">
                {t.createdBy}
            </div>
            <div className="footer-contact" style={{ marginTop: '20px' }}>
                <a
                    href="https://linktr.ee/MarceloReyes05"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-button"
                    title={t.contactMe}
                >
                    <span className="contact-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ display: 'block' }}
                        >
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        </svg>
                    </span>
                    <span className="contact-text">{t.contactMe}</span>
                </a>
            </div>
        </footer>
    );
};

export default Footer;
